import {Box} from 'platform/foundation';

import {useCallback} from 'react';
import {useWatch} from 'react-hook-form';

import {uniqBy} from 'ramda';
import {isFunction} from 'ramda-adjunct';

import {
  SaleVehicle,
  SaleVehiclePhoto,
  useVehicleFormContext,
  VehicleForm as VFKit,
} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';

import {SimpleAlbum} from '../components/SimpleAlbum';

export const SalePhotos = () => {
  const {formApi} = useVehicleFormContext<SaleVehicle>();

  const images = useWatch({
    control: formApi.control,
    name: 'photos',
  });

  const onImagesChange = useCallback(
    (images: SaleVehiclePhoto[] | ((prevImages: SaleVehiclePhoto[]) => SaleVehiclePhoto[])) => {
      const prevImages = formApi.getValues('photos') ?? [];
      const newPhotos = isFunction(images) ? images(prevImages) : (images ?? []);
      // sometimes drag handles are called multiple times, which could cause duplicates
      const deduplicatedPhotos = uniqBy((photo) => photo.fileId, newPhotos);
      formApi.setValue('photos', deduplicatedPhotos);
    },
    [formApi]
  );

  return (
    <Box padding={4} height="100%">
      <VFKit.Section data-testid="sale-photos" title={i18n.t('entity.vehicle.labels.photos')}>
        <VFKit.Field<SaleVehicle, 'chips'>
          name="targetAlbum"
          type="chips"
          label={i18n.t('entity.vehicle.labels.targetAlbum')}
          options={[
            {value: 'PHOTOS_CAR_SALES', label: i18n.t('entity.vehicle.labels.photosCarSales')},
            {
              value: 'PHOTOS_CAR_PURCHASE',
              label: i18n.t('entity.vehicle.labels.photosCarPurchase'),
            },
          ]}
        />

        <SimpleAlbum
          data-testid="sale-photos"
          images={images ?? []}
          onImagesChange={onImagesChange}
        />
      </VFKit.Section>
    </Box>
  );
};
